import React, { useState } from 'react'
import { ImImages } from 'react-icons/im'
import { PiHeartStraightFill } from 'react-icons/pi'
import { FaRegNewspaper, FaYoutube } from 'react-icons/fa6'
import Images from '../images/Images'
import Posts from '../posts/Posts'
import Videos from '../videos/Videos'
import Relation from '../relation/Relation'
import './pages.css'

const Pages = () => {

      const [current, setCurrent] = useState('posts')

      const setPage = (page) => {
            setCurrent(page)
      }

      return (
            <div className="wrapper_pages">
                  <nav className="navbar_pages">
                        <div className="pages_content__menu flex">
                              <button className={current === 'images' ? "btn_pages active flex" : "btn_pages flex"} onClick={() => setPage('images')}>
                                    <div className="btn_icon flex">
                                          <ImImages />
                                    </div>
                                    <div className="btn_hover"></div>
                              </button>
                              <button className={current === 'posts' ? "btn_pages active flex" : "btn_pages flex"} onClick={() => setPage('posts')}>
                                    <div className="btn_icon flex">
                                          <FaRegNewspaper />
                                    </div>
                                    <div className="btn_hover"></div>
                              </button>
                              <button className={current === 'videos' ? "btn_pages active flex" : "btn_pages flex"} onClick={() => setPage('videos')}>
                                    <div className="btn_icon flex">
                                          <FaYoutube />
                                    </div>
                                    <div className="btn_hover"></div>
                              </button>
                              <button className={current === 'relationship' ? "btn_pages active flex" : "btn_pages flex"} onClick={() => setPage('relationship')}>
                                    <div className="btn_icon flex">
                                          <PiHeartStraightFill />
                                    </div>
                                    <div className="btn_hover"></div>
                              </button>
                        </div>
                  </nav>
                  <section className="pages_section__content">
                        <Images current={current} /> 
                        <Posts current={current} /> 
                        <Videos current={current} /> 
                        <Relation current={current} />
                  </section>
                  <footer className="footer_main flex">
                        <h4>xatme.com</h4>
                        <span>Xatspace Designer / Api Rest</span>
                        <p>JasonOficial &#x28;1202&#x29; - xat.com/centraldosplayers</p>
                  </footer>
            </div>
      )
}

export default Pages
